module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (6).2ccaeeaf.svg";